export default "__VITE_ASSET__a7b9264b__"